/**
 * Prompt generation credits the user still has, from a /prompt-generation-credits/ response.
 *
 * The endpoint reports three numbers -- the plan's allowance, whatever was bought on top of it,
 * and how much has been spent -- and every screen that shows "N prompt generation left" is
 * showing those three combined. Spending can overshoot the allowance, so the result is clamped:
 * nothing left is nothing left, and "-3 left" is not a thing to tell someone.
 *
 * The prompt generator, its topic step and the prompts history each work this out inline; they
 * predate this helper, which is where new callers should come.
 */
export function getAvailablePromptCredits(data) {
    const available =
        (data?.allowed_per_plan ?? 0) + (data?.extra_allowed ?? 0) - (data?.total_used ?? 0);

    return available > 0 ? available : 0;
}
